export class CompanyDto {
  id: string = "";
  companyName: string = "";
  organisationNumber: string = "";
  operatingCountryCode: string = "";
}
